import { render, staticRenderFns } from "./OldAQDetails.vue?vue&type=template&id=458a48c8&scoped=true"
import script from "./OldAQDetails.vue?vue&type=script&lang=js"
export * from "./OldAQDetails.vue?vue&type=script&lang=js"
import style0 from "./OldAQDetails.vue?vue&type=style&index=0&id=458a48c8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "458a48c8",
  null
  
)

export default component.exports